import { createQuery } from '../common';
import { getAggregations } from '../apis';

async function queryAggregations() {
  const aggregations = await getAggregations();

  const aggregationMap = aggregations.reduce((acc, it) => {
    acc.set(`${it.id}@${it.type}`, it);
    return acc;
  }, new Map<`${string}@${(typeof aggregations)[0]['type']}`, (typeof aggregations)[0]>());

  const aggregationOptions = aggregations.map((it) => ({
    ...it,
    label: it.name,
    value: it.id,
  }));

  return { aggregations, aggregationMap, aggregationOptions };
}

export const QUERY_KEY_AGGREGATIONS = `/gm/v1/metadata/aggregations` as const;

export const useAggregations = createQuery({
  queryKey: [QUERY_KEY_AGGREGATIONS],
  queryFn: queryAggregations,
  staleTime: Infinity,
  cacheTime: Infinity,
});
